__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-09-17-1789649994-stable-dev/";